import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBsIz7diOd-_ifgZQ-z0TWZrlsMVkjBx3o",
  authDomain: "grindcards-eb016.firebaseapp.com",
  projectId: "grindcards-eb016",
  storageBucket: "grindcards-eb016.firebasestorage.app",
  messagingSenderId: "871862376525",
  appId: "1:871862376525:web:50f7226e170e7f63702404"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();